import { HashRouter, Route, Routes } from "react-router-dom";
import NotFound from "../pages/NotFound";
import PrivateRoute from "./privateRoute";
import { routes } from "./routes";
import PublicRoute from "./publicRoute";

const Router = () => {
  return (
    <HashRouter basename="/">
      <Routes>
        {/* General Routes */}

        <Route element={<PublicRoute />}>
          {routes.map(
            (route) =>
              !route.protected && (
                <Route
                  path={route.path}
                  element={<route.element />}
                  key={route.path}
                />
              )
          )}
        </Route>
        {/* Privte Routes */}
        <Route element={<PrivateRoute />}>
          {routes.map(
            (route) =>
              route.protected && (
                <Route
                  path={route.path}
                  element={<route.element />}
                  key={route.path}
                />
              )
          )}
        </Route>

        {/* Catch routes */}
        <Route path="*" element={<NotFound />} key="Error404" />
      </Routes>
    </HashRouter>
  );
};

export default Router;
